import { LCLSTRG_LANEID_SUFFIX, LCLSTRG_AUCTIONID_SUFFIX } from '../constants';

export const getRouteFromPathName = () =>
  window.location.pathname.split('/')[1];

export const removeStoredSessionValue = (key) =>
  window.sessionStorage.removeItem(key);
export const getStoredSessionValue = (key) =>
  window.sessionStorage.getItem(key);
export const setStoredSessionValue = (key, value) =>
  window.sessionStorage.setItem(key, value);

export const setStoredValue = (key, value) =>
  window.localStorage.setItem(key, value);

export const getStoredValue = (key) => window.localStorage.getItem(key);

export const removeStoredValue = (key) => window.localStorage.removeItem(key);

export const clearStorage = () => {
  window.sessionStorage.clear();
  window.localStorage.clear();
};

export const setStoredAuctionIdByPath = (value, path = null) => {
  setStoredValue(
    `${
      path?.toLowerCase() ?? getRouteFromPathName().toLowerCase()
    }${LCLSTRG_AUCTIONID_SUFFIX}`,
    value,
  );
};

export const getStoredAuctionLaneIdByPath = () =>
  getStoredValue(
    `${getRouteFromPathName().toLowerCase()}${LCLSTRG_LANEID_SUFFIX}`,
  );

export const setStoredAuctionLaneIdByPath = (value, path = null) =>
  setStoredValue(
    `${
      path?.toLowerCase() ?? getRouteFromPathName().toLowerCase()
    }${LCLSTRG_LANEID_SUFFIX}`,
    value,
  );

export const removeStoredAuctionLaneIdByPath = () =>
  removeStoredValue(
    `${getRouteFromPathName().toLowerCase()}${LCLSTRG_LANEID_SUFFIX}`,
  );

export const getStoredAuctionIdByPath = () =>
  getStoredValue(
    `${getRouteFromPathName().toLowerCase()}${LCLSTRG_AUCTIONID_SUFFIX}`,
  );

export const removeStoredAuctionIdByPath = () =>
  removeStoredValue(
    `${getRouteFromPathName().toLowerCase()}${LCLSTRG_AUCTIONID_SUFFIX}`,
  );
